import React, { Component } from "react";
import { Grid } from "@mui/material";
import { forgottenPasswordBegin } from "../actions/forgottenpasswordactions";
import * as EmailValidator from "email-validator";
import { reportError } from "../actions/erroractions";
import { connect } from "react-redux";
import ClipLoader from "react-spinners/ClipLoader";
import { moveToLoginPage } from "../actions/routeactions";

class ForgottenPassword extends Component {
  state = {
    email: "",
  };

  constructor(props) {
    super(props);

    this.changeEmail = this.changeEmail.bind(this);
    this.sendEmail = this.sendEmail.bind(this);
    this.renderButton = this.renderButton.bind(this);
    this.renderSpinner = this.renderSpinner.bind(this);
    this.backToLogin = this.backToLogin.bind(this);
  }

  changeEmail(e) {
    this.setState({
      email: e.target.value,
    });
  }

  sendEmail() {
    const { dispatch } = this.props;
    const { email } = this.state;

    if (!EmailValidator.validate(email)) {
      dispatch(reportError("Invalid email address"));
    } else {
      dispatch(forgottenPasswordBegin(email));
    }
  }

  backToLogin() {
    const { dispatch } = this.props;
    dispatch(moveToLoginPage());
  }

  renderSpinner() {
    const { loading } = this.props;
    return (
      <ClipLoader color="#FFFFFF" sizeUnit={"%"} size={100} loading={loading} />
    );
  }

  renderButton() {
    return (
      <React.Fragment>
        <button className="bbe-button" onClick={this.sendEmail}>
          Send Email
        </button>
        <p className="hyperlink" onClick={this.backToLogin}>
          <u>Sign in?</u>
        </p>
      </React.Fragment>
    );
  }

  render() {
    const { loading } = this.props;

    return (
      <Grid container alignItems="center" justifyContent="center">
        <div className="form login_form">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <h2>Forgotten Password</h2>
            </Grid>
            <Grid item xs={12}>
              <label className="label">Email</label>
            </Grid>
            <Grid item xs={12}>
              <input
                type="text"
                className="textbox logintext"
                onChange={this.changeEmail}
              />
            </Grid>
            <Grid item xs={12}>
              {loading ? this.renderSpinner() : this.renderButton()}
            </Grid>
          </Grid>
        </div>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.forgottenPassword.loading,
});

export default connect(mapStateToProps)(ForgottenPassword);
